import {
	Checkbox,
	mergeStyleSets,
	TextField,
} from '@fluentui/react';
import { observer } from 'mobx-react';
import { EntityTypeEditorState } from '../EntityTypeEditor';
import { InfoTooltipLabel } from '../../../controls/InfoTooltipLabel';

const contentStyles = mergeStyleSets({
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: '5px',
	}
});

function EntityTypeOutlookSettings({
	state
}: {
	state: EntityTypeEditorState;
}) {
	
	return (
		<section className={contentStyles.section}>
			
			<InfoTooltipLabel label='Enable Helm Filing "Create New" option' title={`Allow users to create new items of this list in the Helm Filing for Outlook add-in.`}>
				<Checkbox
					label={'Enable "Create New" option'}
					defaultChecked={state.OutlookEnableCreateNewOption}
					onChange={(e, checked) => { state.setOutlookEnableCreateNewOption(!!checked); }}
				/>
			</InfoTooltipLabel>

			<InfoTooltipLabel label='Enable Helm Filing "View All" option' title={`Allow users to view all items of this list in the Helm Filing for Outlook add-in.`}>
				<Checkbox
					label={'Enable "View All" option'}
					defaultChecked={state.OutlookEnableViewAllOption}
					onChange={(e, checked) => { state.setOutlookEnableViewAllOption(!!checked); }}
				/>
			</InfoTooltipLabel>
			
			<InfoTooltipLabel label='Include in Helm Filing search results' title={`Include results of this list in the Helm Filing for Outlook search results.`}>
				<Checkbox
					label={'Include in search results'}
					defaultChecked={state.OutlookIncludeInSearchResults}
					onChange={(e, checked) => { state.setOutlookIncludeInSearchResults(!!checked); }}
				/>
			</InfoTooltipLabel>

			<InfoTooltipLabel 
					label='Filing tag format'
					title={`Template for email filing tags added to outgoing messages. For example, you can use "{{ Tag.Id }}" or "{{ Tag.IdBase36 }}" to generate a unique tag ID, or {{ Item.FieldInternalName }} to get a field from the SharePoint list. By default, a unique tag ID will be assigned. Square brackets are always added.`}>
				<TextField
							defaultValue={state.OutlookFilingTagTemplate}
							onChange={(e, val) => {state.setOutlookFilingTagTemplate(val ?? '' ); }}
						/>
			</InfoTooltipLabel>

			<InfoTooltipLabel 
					label='Template documents'
					title={`URL to the template documents library. If documents are present, a 'New Document' option will appear in outlook.`}>
				<TextField
							defaultValue={state.SharePointTemplateDocumentsLibraryUrl}
							onChange={(e, val) => {state.setSharePointTemplateDocumentsLibraryUrl(val ?? '' ); }}
						/>
			</InfoTooltipLabel>
			

		</section>
	);
}

export default observer(EntityTypeOutlookSettings);
